import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title, 
  description, 
  keywords,
  ogImage = "https://customer-assets.emergentagent.com/job_blackbird-redesign/artifacts/c7xxbrm7_The-port-of-Singapore.jpg",
  path = "/",
  type = "website"
}) => {
  const siteUrl = "https://blackbirdtradegroup.com";
  const fullUrl = `${siteUrl}${path}`;
  const siteName = "Blackbird Trade Group";
  const fullTitle = title ? `${title} | ${siteName}` : `${siteName} - Trade Compliance Advisory`;

  // Organization Schema
  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "ProfessionalService",
    "name": "Blackbird Trade Group",
    "description": "Expert trade compliance advisory and consulting services for international trade, export controls, ITAR, EAR, and customs regulations.",
    "url": siteUrl,
    "logo": `${siteUrl}/logo.png`,
    "founder": {
      "@type": "Person",
      "name": "Nancy Gazzano",
      "jobTitle": "Trade Compliance Consultant"
    },
    "address": {
      "@type": "PostalAddress",
      "addressCountry": "US"
    },
    "email": "nwood@blackbirdtradegroup.com",
    "telephone": "+1-904-512-1329",
    "areaServed": "Worldwide",
    "serviceType": ["Trade Compliance", "Export Controls", "Product Classification", "ITAR Compliance", "Foreign Trade Zones"],
    "sameAs": [
      "https://www.linkedin.com/in/nancy-wood-bb9ba319"
    ]
  };

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="title" content={fullTitle} />
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:site_name" content={siteName} />
      
      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={fullUrl} />
      <meta property="twitter:title" content={fullTitle} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={ogImage} />
      
      {/* Canonical URL */}
      <link rel="canonical" href={fullUrl} />
      
      {/* Organization Schema - only on homepage */}
      {path === "/" && (
        <script type="application/ld+json">
          {JSON.stringify(organizationSchema)}
        </script>
      )}
    </Helmet>
  );
};

export default SEO;
